// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commonCollapser{
    display: grid;
    grid-template-rows: 0fr;
    transition-duration: 200ms;
    transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
    overflow: hidden;
    /*height: 100%;*/
}

.commonCollapser--collapsed{
    flex-shrink: 0;;
    grid-template-rows: 1fr;
}

.commonCollapser_content{
    display: flex;
    flex-direction: column;
    height: 100%;;
    overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/components/collapser/Collapser.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,0BAA0B;IAC1B,+DAA+D;IAC/D,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;AACpB","sourcesContent":[".commonCollapser{\n    display: grid;\n    grid-template-rows: 0fr;\n    transition-duration: 200ms;\n    transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);\n    overflow: hidden;\n    /*height: 100%;*/\n}\n\n.commonCollapser--collapsed{\n    flex-shrink: 0;;\n    grid-template-rows: 1fr;\n}\n\n.commonCollapser_content{\n    display: flex;\n    flex-direction: column;\n    height: 100%;;\n    overflow: hidden;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
